export var EventKey;
(function (EventKey) {
    EventKey["NEW_SESSION"] = "NEW_SESSION";
    EventKey["PLAYER_INITIALIZED"] = "PLAYER_INITIALIZED";
    EventKey["STREAM_LOADING"] = "STREAM_LOADING";
    EventKey["STREAM_LOADED"] = "STREAM_LOADED";
    EventKey["READY"] = "READY";
    EventKey["BUFFERING"] = "BUFFERING";
    EventKey["PLAY"] = "PLAY";
    EventKey["PLAYING"] = "PLAYING";
    EventKey["PAUSE"] = "PAUSE";
    EventKey["PAUSED"] = "PAUSED";
    EventKey["SEEK"] = "SEEK";
    EventKey["SEEKING"] = "SEEKING";
    EventKey["SEEKED"] = "SEEKED";
    EventKey["QUALITY_CHANGED"] = "QUALITY_CHANGED";
    EventKey["TRACK_AUDIO_CHANGED"] = "TRACK_AUDIO_CHANGED";
    EventKey["TRACK_SUBTITLES_CHANGED"] = "TRACK_SUBTITLES_CHANGED";
    EventKey["NETWORK_CHANGED"] = "NETWORK_CHANGED";
    EventKey["GEOMETRY_CHANGED"] = "GEOMETRY_CHANGED";
    EventKey["VOLUME_CHANGED"] = "VOLUME_CHANGED";
    EventKey["RATE_CHANGED"] = "RATE_CHANGED";
    EventKey["CLOSE"] = "CLOSE";
    EventKey["CLOSED"] = "CLOSED";
    EventKey["ENDED"] = "ENDED";
    EventKey["STATUS"] = "STATUS";
    EventKey["DROPPED_FRAMES"] = "DROPPED_FRAMES";
    EventKey["ERROR"] = "ERROR";
    EventKey["LATENCY"] = "LATENCY";
    EventKey["LOG"] = "LOG";
    EventKey["CUSTOM"] = "CUSTOM";
    // Ads
    EventKey["AD_REQUESTED"] = "AD_REQUESTED";
    EventKey["AD_RECEIVED"] = "AD_RECEIVED";
    EventKey["AD_BREAK_START"] = "AD_BREAK_START";
    EventKey["AD_BREAK_END"] = "AD_BREAK_END";
    EventKey["AD_BREAK_SKIPPED"] = "AD_BREAK_SKIPPED";
    EventKey["AD_LOADED"] = "AD_LOADED";
    EventKey["AD_STARTED"] = "AD_STARTED";
    EventKey["AD_PAUSED"] = "AD_PAUSED";
    EventKey["AD_END"] = "AD_END";
    EventKey["AD_SKIPPED"] = "AD_SKIPPED";
    EventKey["AD_ERROR"] = "AD_ERROR";
})(EventKey || (EventKey = {}));
